import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getMyProfile } from '../api/public';
import { isAuthenticated } from './cognito';

export default function RequirePaid({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'loading' | 'paid' | 'unpaid'>('loading');

  useEffect(() => {
    if (!isAuthenticated()) { setStatus('unpaid'); return; }
    getMyProfile().then(profile => {
      setStatus(profile?.plan === 'paid' ? 'paid' : 'unpaid');
    });
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ color: '#a78bfa', fontSize: 16 }}>Checking access...</div>
      </div>
    );
  }

  if (status === 'unpaid') return <Navigate to="/subscribe" replace />;

  return <>{children}</>;
}
